import { TPagination } from '../../hooks/use-pagination'
import { PaginationContainer } from './styles'
// import { BiSolidRightArrow } from 'react-icons/bi'
interface IProps {
  pagination: TPagination
  isLoading?: boolean
}

const Pagination = (props: IProps) => {
  const { pagination } = props

  return (
    <PaginationContainer>
      <button
        className="prev-page"
        disabled={pagination.active === 1 || props.isLoading}
        onClick={() => pagination.previous()}
      >
        {'<'}
      </button>
      {pagination.range.map((item, idx) => {
        if (item === 'dots')
          return (
            <span key={item + idx} className="dots">
              ...
            </span>
          )

        return (
          <button
            key={item}
            type="button"
            className="page-button"
            onClick={() => pagination.setPage(item)}
            data-active={pagination.active === item}
            disabled={props.isLoading}
          >
            {new Intl.NumberFormat('pt-BR').format(item)}
          </button>
        )
      })}
      <button
        className="next-page"
        onClick={() => pagination.next()}
        disabled={pagination.active === pagination.total || props.isLoading}
      >
        {'>'}
      </button>
    </PaginationContainer>
  )
}

export default Pagination
